// Single global document click handler for all instances
if (!window._simpleBundlesOptionsDocumentClickHandler) {
  window._simpleBundlesOptionsDocumentClickHandler = function(e) {
    document.querySelectorAll('simple-bundles-options').forEach((element) => {
      if (!element.contains(e.target)) {
        element.closeAllLists();
      }
    });
  };
  document.addEventListener('click', window._simpleBundlesOptionsDocumentClickHandler);
}

class SimpleBundlesOptions extends HTMLElement {
  constructor() {
    super();
    this.closeAllLists = this.closeAllLists.bind(this);
    this._initialized = false;
  }

  connectedCallback() {
    if (!this._initialized) {
      this.init();
      this._initialized = true;
    }
  }

  reinit() {
    this._initialized = false;
    this.init();
    this._initialized = true;
  }

  init() {
    this.setupDropdowns();
    this.initializeSelects();
    this.setupChangeListeners();
    this.updateHiddenInputValue();
  }

  updateHiddenInputValue() {
    const selects = this.querySelectorAll('select');
    const values = [];

    selects.forEach((select) => {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value !== "") {
        values.push(selectedOption.value);
      }
    });

    if (values.length === 0) {
      return;
    }

    const hiddenInputValue = values.join(' <> ');
    let hiddenInput = this.querySelector('input[name="properties[_bundle_selection]"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[_bundle_selection]';
      // Get form ID from the first select element if it exists
      const firstSelect = selects[0];
      if (firstSelect && firstSelect.hasAttribute('form')) {
        hiddenInput.setAttribute('form', firstSelect.getAttribute('form'));
      }
      this.appendChild(hiddenInput);
    }
    hiddenInput.value = hiddenInputValue;
  }

  setToggleVisual(dropdown, optionEl) {
    const toggle = dropdown.querySelector('.product-bundle-option__toggle');
    const label = dropdown.querySelector('.product-bundle-option__label');
    const thumb = dropdown.querySelector('.product-bundle-option__thumb');
    if (!toggle || !label || !thumb) return;
    
    if (optionEl) {
      label.textContent = optionEl.querySelector('.product-bundle-option__text')?.textContent.trim() || optionEl.textContent.trim();
      
      const imageSrc = optionEl.dataset.image;
      if (imageSrc) {
        thumb.innerHTML = '';
        const img = document.createElement('img');
        img.src = imageSrc;
        img.alt = optionEl.querySelector('.product-bundle-option__text')?.textContent.trim() || optionEl.textContent.trim();
        img.className = 'product-variant__item-swatch product-variant__item-swatch--color';
        img.style.width = '1.75rem';
        img.style.height = '1.75rem';
        img.style.objectFit = 'cover';
        img.style.borderRadius = '100%';
        img.style.boxShadow = 'var(--color-borders-main) 0 0 1px 1px';
        thumb.appendChild(img);
      } else {
        thumb.innerHTML = '<span class="product-variant__item-swatch product-variant__item-swatch--color" style="width: 1.75rem; height: 1.75rem;"></span>';
      }
    } else {
      label.textContent = toggle.dataset.defaultLabel || 'Bitte wählen';
      thumb.innerHTML = '<span class="product-variant__item-swatch product-variant__item-swatch--color" style="width: 1.75rem; height: 1.75rem;"></span>';
    }
  }

  syncDropdownFromSelect(select) {
    const target = select.id;
    const dropdown = this.querySelector('.product-bundle-option[data-target="' + target + '"]');
    if (!dropdown) return;
    
    const selectedOption = select.options[select.selectedIndex];
    const list = dropdown.querySelector('.product-bundle-option__list');
    let optionEl = null;
    
    if (selectedOption && selectedOption.value !== "") {
      optionEl = list?.querySelector('[data-value="' + selectedOption.value + '"]');
    }
    
    this.setToggleVisual(dropdown, optionEl);
  }

  closeAllLists() {
    this.querySelectorAll('.product-bundle-option__list').forEach((list) => {
      list.hidden = true;
    });
    this.querySelectorAll('.product-bundle-option__toggle').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('.product-bundle-option').forEach((drop) => {
      drop.classList.remove('is-open');
    });
  }

  setupDropdowns() {
    this.querySelectorAll('.product-bundle-option').forEach((dropdown) => {
      const toggle = dropdown.querySelector('.product-bundle-option__toggle');
      const list = dropdown.querySelector('.product-bundle-option__list');
      if (!toggle || !list) return;

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        this.closeAllLists();
        if (!isOpen) {
          dropdown.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          list.hidden = false;
        }
      });

      list.querySelectorAll('.product-bundle-option__item').forEach((item) => {
        item.addEventListener('click', () => {
          if (item.classList.contains('disabled')) return;
          const selectId = dropdown.dataset.target;
          const select = this.querySelector('#' + selectId);
          if (!select) return;
          
          select.value = item.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          this.setToggleVisual(dropdown, item);
          this.closeAllLists();
        });

        item.addEventListener('keydown', (evt) => {
          if (evt.key === 'Enter' || evt.key === ' ') {
            evt.preventDefault();
            item.click();
          }
        });
      });
    });
  }

  initializeSelects() {
    const selects = this.querySelectorAll('select');
    selects.forEach((select) => {
      if (!select.value || select.value === '') {
        const firstEnabled = Array.from(select.options).find(
          (opt) => !opt.disabled && opt.value !== ''
        );
        if (firstEnabled) firstEnabled.selected = true;
      }
      this.syncDropdownFromSelect(select);
    });
    
  }

  setupChangeListeners() {
    const selects = this.querySelectorAll('select');
    selects.forEach((select) => {
      select.addEventListener('change', () => {
        this.syncDropdownFromSelect(select);
        this.updateHiddenInputValue();
      });
    });
  }
}

customElements.define('simple-bundles-options', SimpleBundlesOptions);

// Listen for variant changes and reinitialize after DOM updates
function setupVariantChangeListener() {
  const productVariants = document.querySelector('product-variants[data-main-product-variants]');
  if (!productVariants) return;

  productVariants.addEventListener('VARIANT_CHANGE', () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('simple-bundles-options').forEach((element) => {
        if (element.reinit) {
          element.reinit();
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupVariantChangeListener);
} else {
  setupVariantChangeListener();
}

